import {
    OPPORTUNITIES,
    COMPANIES,
    CONTACTS,
    AGENDA,
    ACTIVITIES,
    SALESORDERS,
} from 'constants/Entities';
import { getDetailRouteIfAllowed } from 'utils/fm';

export const getContactFormUrl = (id) => getDetailRouteIfAllowed({ entity: CONTACTS, id });

export const getCompanyDetailUrl = (id) => getDetailRouteIfAllowed({ entity: COMPANIES, id });

export const getContactDetailUrl = (id) => getDetailRouteIfAllowed({ entity: CONTACTS, id });

export const getOpportunityDetailUrl = (id) =>
    getDetailRouteIfAllowed({ entity: OPPORTUNITIES, id });

export const getCalendarDetailUrl = (id) => getDetailRouteIfAllowed({ entity: AGENDA, id });

export const getActivityDetailUrl = (id, activityType, tab) =>
    getDetailRouteIfAllowed({ entity: ACTIVITIES, id, activityType, tab });

export const getSalesOrdersDetailUrl = (id) => getDetailRouteIfAllowed({ entity: SALESORDERS, id });

export const getUserSfmUrl = (id) => `/web3/index.html?iu=${id}#/analytics/intensity`;

export const getSalesOrdersUrl = (entity, action, entityFrom, idFrom, nameFrom, rate, company) => {
    const url = `#/sales-orders`;
    let params = '';
    let separator = '?';

    if (entity) {
        params = `${params}${separator}entity=${entity}`;
        separator = '&';
    }

    if (action) {
        params = `${params}${separator}action=${action}`;
        separator = '&';
    }

    if (entityFrom) {
        params = `${params}${separator}entityfrom=${entityFrom}`;
        separator = '&';
    }

    if (idFrom) {
        params = `${params}${separator}idfrom=${idFrom}`;
        separator = '&';
    }

    if (nameFrom) {
        params = `${params}${separator}namefrom=${nameFrom}`;
        separator = '&';
    }

    if (rate?.id && rate?.id !== '-1') {
        params = `${params}${separator}idRate=${rate.id}`;
        separator = '&';
    }

    if (rate?.label) {
        params = `${params}${separator}rate=${rate.label}`;
        separator = '&';
    }

    if (company?.id && company?.id !== '-1') {
        params = `${params}${separator}companyId=${company.id}`;
        separator = '&';
    }

    if (company?.label) {
        params = `${params}${separator}companyName=${company.label}`;
        separator = '&';
    }

    return `${params}${url}`;
};
